import React from 'react';

export class HelpMenu extends React.Component {
    handleClickBack = () => {
        this.props.setActiveMenu('tray');
    }

    renderItem = (item, index) => {
        if (item.cssClass === 'divider') {
            return (
                <div className="site-header-divider" key={`divider-${index}`} />
            );
        }

        if (item.cssClass === 'nav-header') {
            return (
                <div className="site-header-tray__menu-item-header" key={`header-${index}`}>{item.text}</div>
            );
        }

        return (
            <a className="site-header-tray__menu-item-link site-header-tray__menu-item-link--help" data-bypass="true" href={item.link} key={`link-${index}`}>{item.text}</a>
        );
    }

    render() {
        return (
            <div className="site-header-tray__menu">
                <div
                    className="site-header-tray__menu-header"
                    onClick={this.handleClickBack}
                    onKeyPress={this.handleClickBack}
                    role="button"
                    tabIndex={0}
                >
                    <span className="site-header-tray__menu-back"><i aria-hidden="true" className="icon-chevron-left" />{this.props.help.back}</span>
                </div>
                <div className="site-header-tray__items">
                    {this.props.help.items.map(this.renderItem)}
                </div>
            </div>
        );
    }
}
